import React from "react";
import PropTypes from "prop-types";

import { Generic, Field, Control, Label, Select, Icon, Help } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useQuery } from "react-apollo";
import { Link } from "react-router-dom";

import { ALL_LOCATIONS_QUERY } from "../../graphql/Locations/Locations.graphql";
import { ourToast as toast } from "../../utils";

const LocationKeySelect = ({
  value,
  label,
  size,
  valueKey,
  name,
  onChange,
  icon,
  required,
  readOnly,
  where,
  disabled,
  attrKey
}) => {
  const { data, loading, error } = useQuery(ALL_LOCATIONS_QUERY, {
    variables: {
      where,
      orderByMulti: [`${attrKey}_ASC`]
    },
    fetchPolicy: "cache-and-network"
  });
  if (error) {
    toast.error("Error getting Locations.");
  }
  const selectedLocation = data?.Locations?.find(
    l => l.RecId === parseInt(value)
  );
  const custLabel = `${label} ${attrKey.replace(/location/gi, "")}`;
  return (
    <Field>
      <Label size={size}>{custLabel}</Label>
      <Control iconLeft size={size}>
        <Select.Container
          fullwidth
          color={error ? "danger" : "secondary"}
          size={size}
          state={loading ? "loading" : null}
        >
          {data && data.Locations ? (
            <Select
              disabled={disabled || readOnly || loading}
              name={name}
              required={required}
              value={value}
              onChange={onChange}
            >
              <Select.Option value={0}>{custLabel}</Select.Option>
              {!loading &&
                data.Locations.map((Location, i) => (
                  <Select.Option
                    key={`location-select-${i}`}
                    value={Location[valueKey]}
                  >
                    {Location[attrKey]}
                  </Select.Option>
                ))}
            </Select>
          ) : null}
        </Select.Container>
        {icon && (
          <Icon align="left" size="small">
            <FontAwesomeIcon icon={icon} />
          </Icon>
        )}
      </Control>
      <Help as={Label} style={{ marginLeft: "2.5rem" }}>
        <Generic
          as={Link}
          tabIndex="-1"
          textColor="link"
          to={`/dispatch/locations/${selectedLocation?.RecId}/details`}
        />
      </Help>
    </Field>
  );
};
LocationKeySelect.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  onChange: PropTypes.func,
  label: PropTypes.string,
  size: PropTypes.string,
  valueKey: PropTypes.string,
  icon: PropTypes.string,
  required: PropTypes.bool,
  readOnly: PropTypes.bool,
  where: PropTypes.object,
  disabled: PropTypes.bool,
  attrKey: PropTypes.string
};
LocationKeySelect.defaultProps = {
  value: 0,
  valueKey: "RecId",
  where: {},
  attrKey: "LocationID"
};
export default LocationKeySelect;
